import { Component } from 'react';
import { connect } from 'react-redux';
import { get } from './actions';

class FeatureFlags extends Component {

    componentDidMount() {
        this.props.get();
    }

    componentWillReceiveProps({ featureFlags }) {
        if ((featureFlags.refresh && !this.props.featureFlags.refresh)) {// || (user.isProfileReady && !this.props.user.isProfileReady)) {
            this.props.get();
        }
    }

    render() {
        return null;
    }
}

function bindAction(dispatch) {
    return {
        get: () => dispatch(get())
    };
}

function mapStateToProps(state) {
    return {
        featureFlags: state.featureFlags
    };
}

export default connect(mapStateToProps, bindAction)(FeatureFlags);


